import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const TMS_STAFF_ROLES = ["admin", "dispatcher", "biller"];

export function portalPathForRole(userRole) {
  if (userRole === "carrier") return "/portal/carrier";
  if (TMS_STAFF_ROLES.includes(userRole)) return "/portal/tms";
  return "/portal/customer";
}

export default function ProtectedRoute({ role, anyOf, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const redirectState = useMemo(() => ({ from: loc }), [loc]);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-slate-500">Loading…</div>;
  }
  if (!user) {
    return <Navigate to={`/login?role=${role || "customer"}`} state={redirectState} replace />;
  }
  const allowed = anyOf && anyOf.length
    ? anyOf.includes(user.role)
    : role
      ? user.role === role
      : true;
  if (!allowed) return <Navigate to={portalPathForRole(user.role)} replace />;
  return children;
}
